import React, { useEffect, useState } from "react";
/*コンテナ（画面レイアウト）デザイン*/
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Container, InputGroup, FormControl,Row,Col } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import API, { graphqlOperation } from "@aws-amplify/api";
import {
  listEndUserSpecialPricings,
  customerByeMail,
  queryEndUserSpecialPricingsByOrderCodeIndex,
} from "../graphql/queries";
import { updateEndUserSpecialPricing } from "../graphql/mutations";
import { Auth } from "aws-amplify";
import userAuth from "../components/userAuth";
import { message } from "antd";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from "@mui/material/CircularProgress";
const useStyles = makeStyles((theme) => ({
  fixedTop: {
    position: "sticky",
    top: 0,
    boxShadow: "0 -1px 0 0 white,0 3px 0 0 #804F29,0 3px 0 0 transparent",
    backgroundColor: "white",
    zIndex: 9,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "20ch",
  },
  textFieldNm: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "60ch",
  },
  textKField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "60ch",
  },
  textlabel: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "rgb(91,56,9)",
    border: "1px solid #707070",
    color: "white",
    fontWeight: "bold",
    fontSize: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    width:'20%',
  },
  textFieldSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "transparent",
    border: "1px solid #707070",
    borderRadius: "6px",
    color: "black",
    width:'80%'
  },
}));
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {size} の結果の {from} から {to} を表示しています
    </span>
  );
  const pageButtonRenderer = ({ page, onPageChange, currSizePerPage }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    return (
      <button
      key={page}
        className={`btn ${currSizePerPage === `${page}` ? "btn-warning" : "btn-light"
          }`}
        type="button"
        onClick={handleClick}
      >
        <li className="page-item">
          <a style={{ color: "black" }} href="#">
            {page}
          </a>
        </li>
      </button>
    );
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <div className="btn-group" role="group">
      {options.map((option) => (
        <button
          key={option.text}
          type="button"
          onClick={() => onSizePerPageChange(option.page)}
          className={`btn ${currSizePerPage === `${option.page}` ? "btn-warning" : "btn-light"
            }`}
        >
          {option.text}
        </button>
      ))}
    </div>
  );
  const options = {
    paginationSize: 20,
    pageStartIndex: 1,
    showTotal: true,
    withFirstAndLast: true, // Hide the going to First and Last page button
    firstPageText: "最初",
    prePageText: "戻る",
    nextPageText: "次へ",
    lastPageText: "最後",
    nextPageTitle: "最初のページ",
    prePageTitle: "プレページ",
    firstPageTitle: "次のページ",
    lastPageTitle: "最後のページ",
    paginationTotalRenderer: customTotal,
    sizePerPageRenderer: sizePerPageRenderer,
    pageButtonRenderer: pageButtonRenderer,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      }
    ],
  };
  let dataAll = "";
const EndUserSpecialPricing = () => {
  const [products, setTableData] = useState([]);
  const [Title, setTitle] = useState("");
  const [authDisplay, setauthDisplay] = useState(true);
  const classes = useStyles();
  const [upShow, setUpShow] = useState({
    show: false,
    EndUserCode: "",
    Price: "",
    id: "",
    OrderCode: "",
    ItemCode: "",
  });
  const upShowFun = function (row) {
    setUpShow({
      show: true,
      EndUserCode: row.EndUserCode,
      OrderCode: row.OrderCode,
      ItemCode: row.ItemCode,
      Price: row.Price,
      id:row.id
    });
  };
  const upHiddenFun = function () {
    setUpShow({ ...upShow, show: false });
  };
  const headerStyle = {
    backgroundColor: "white",
    borderBottom: "3px solid #804F29",
  };
  let columns = [
    {
      dataField: "OrderCode",
      text: "受注先コード",
      sort: true,
      headerStyle,
      hidden: authDisplay ? true : false,
      style: { width: "150px", minWidth: "150px", maxWidth: "150px" },
    },
    // {
    //   dataField: "OrderName",
    //   text: "受注先名称",
    //   sort: true,
    //   headerStyle,
    //   hidden: authDisplay ? true : false,
    //   style: { width: "200px",minWidth: "200px", maxWidth: "200px" },
    // },
    {
      dataField: "EndUserCode",
      text: "エンドユーザーコード",
      sort: true,
      headerStyle,
      style: { width: "180px", minWidth: "180px", maxWidth: "180px" },
    },
    // {
    //   dataField: "EndUserName",
    //   text: "エンドユーザー名称",
    //   sort: true,
    //   headerStyle,
    //   style: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    // },
    {
      dataField: "ItemCode",
      text: "品目コード",
      sort: true,
      headerStyle,
      style: {width: "100px", minWidth: "100px", maxWidth: "100px" },
    },
    {
      dataField: "Price",
      text: "価格",
      sort: true,
      headerStyle,
      style: {width: "100px", minWidth: "100px", maxWidth: "100px" },
      formatter: (cellContent) => {
        return <span>{numtomoney(cellContent)}</span>;
      },
    },
    // {
    //   dataField: "SpecialPriceQuoteNum",
    //   text: "特価見積番",
    //   sort: true,
    //   headerStyle,
    //   style: {width: "100px", minWidth: "100px", maxWidth: "100px" },
    // },
    // {
    //   dataField: "SpecialPriceNum",
    //   text: "特価番号",
    //   sort: true,
    //   headerStyle,
    //   style: {width: "100px", minWidth: "100px", maxWidth: "100px" },
    // },
    {
      dataField: "opreate",
      text: "操作",
      style: { margin: "0px", width: "80px", minWidth: "80px", maxWidth: "80px" },
      headerStyle,
      hidden: authDisplay ? true : false,
      formatter: (cellContent, row) => {
        if (row) {
          return (
            <p
              onClick={() => upShowFun(row)}
              style={{ cursor: "pointer", color: "#3f51b5", height: 10 }}
            >
              <span className="cellTxt" style={{ height: 10 }}>
                編集
              </span>
            </p>
          );
        }
      },
    },
  ];
  async function EndUserSpecialPricingInit() {
    try {
      const listArEndUserSpecialPricings = await API.graphql(
        graphqlOperation(listEndUserSpecialPricings, { limit: 1000 })
      );
      if (
        listArEndUserSpecialPricings.data.listEndUserSpecialPricings !== null
      ) {
        let nextToken =
          listArEndUserSpecialPricings.data.listEndUserSpecialPricings
            .nextToken;
        dataAll =
          listArEndUserSpecialPricings.data.listEndUserSpecialPricings.items;
        while (nextToken !== null) {
          let InvDataSec = await API.graphql(
            graphqlOperation(listEndUserSpecialPricings, {
              limit: 1000,
              nextToken: nextToken,
            })
          );
          nextToken = InvDataSec.data.listEndUserSpecialPricings.nextToken;
          for (
            let i = 0;
            i < InvDataSec.data.listEndUserSpecialPricings.items.length;
            i++
          ) {
            dataAll.push(InvDataSec.data.listEndUserSpecialPricings.items[i]);
          }
        }
      }
      let itemCodeList = []
      let endUserCodeList = []
      let orderCodeList = []
      for (let i = 0; i < dataAll.length; i++) {
        if (dataAll[i].EndUserCode) {
            endUserCodeList.push(dataAll[i].EndUserCode)
            itemCodeList.push(dataAll[i].ItemCode)
            orderCodeList.push(dataAll[i].OrderCode)
          }
      }
      dataAll = multiSort(dataAll,sortByOrderCode)
      setItemCodeList(Array.from(new Set(itemCodeList)))
      setEndUserCodeList(Array.from(new Set(endUserCodeList)))
      setOrderCodeList(Array.from(new Set(orderCodeList)))
      setTableData(dataAll);
    } catch (err) {
      console.log(err);
    }
  }
  const [progress, setProgress] = useState(false);
  const [ItemCodeList, setItemCodeList] = useState([])
  const [EndUserCodeList, setEndUserCodeList] = useState([])
  const [OrderCodeList, setOrderCodeList] = useState([])
  const [searchValue, setSearchValue] = useState({
    EndUserCode: "",
    ItemCode: "",
    OrderCode:"",
  })
  const TextEndUserCodeChange = (e, value) => {
        setSearchValue({ ...searchValue, EndUserCode: value ? value : "" })
    }
  const TextItemCodeChange = (e, value) => {
        setSearchValue({ ...searchValue, ItemCode: value ? value : "" })
    }
  const TextOrderCodeChange = (e, value) => {
      setSearchValue({ ...searchValue, OrderCode: value ? value : "" })
  }
  async function searchData() {
    let dataAll = [];
      try{
        const userAuths = await userAuth();
        if (userAuths === "1") {
          const user = await Auth.currentUserInfo();
          const agencyPriceGroup = await API.graphql(
            graphqlOperation(customerByeMail, {
              Agency_Email: user.attributes.email,
            })
          );
          const agentinfo = agencyPriceGroup.data.customerByeMail["items"];
          let agencyId = "";
          if (agentinfo.length > 0) {
            agencyId = agentinfo[0].Agency_id;
          }
          const EndUserlist = await API.graphql(
            graphqlOperation(queryEndUserSpecialPricingsByOrderCodeIndex, {
              OrderCode: agencyId,
              limit: 1000,
            })
          );
          if (
            EndUserlist.data.queryEndUserSpecialPricingsByOrderCodeIndex !== null) {
            let nextToken = EndUserlist.data.queryEndUserSpecialPricingsByOrderCodeIndex.nextToken;
            dataAll = EndUserlist.data.queryEndUserSpecialPricingsByOrderCodeIndex.items;
            while (nextToken !== null) {
              let InvDataSec = await API.graphql(
                graphqlOperation(queryEndUserSpecialPricingsByOrderCodeIndex, {
                  OrderCode: agencyId,
                  limit: 1000,
                  nextToken,
                })
              );
              nextToken = InvDataSec.data.queryEndUserSpecialPricingsByOrderCodeIndex.nextToken;
              for (
                let i = 0;
                i < InvDataSec.data.queryEndUserSpecialPricingsByOrderCodeIndex.items.length;
                i++
              ) {
                dataAll.push(InvDataSec.data.queryEndUserSpecialPricingsByOrderCodeIndex.items[i]);
              }
            }
          }
        } else {
          const listArEndUserSpecialPricings = await API.graphql(
            graphqlOperation(listEndUserSpecialPricings, { limit: 1000 })
          );
          if (listArEndUserSpecialPricings.data.listEndUserSpecialPricings !== null) {
            let nextToken = listArEndUserSpecialPricings.data.listEndUserSpecialPricings.nextToken;
            dataAll = listArEndUserSpecialPricings.data.listEndUserSpecialPricings.items;
            while (nextToken !== null) {
              let InvDataSec = await API.graphql(
                graphqlOperation(listEndUserSpecialPricings, {
                  limit: 1000,
                  nextToken: nextToken,
                })
              );
              nextToken = InvDataSec.data.listEndUserSpecialPricings.nextToken;
              for (
                let i = 0;
                i < InvDataSec.data.listEndUserSpecialPricings.items.length;
                i++
              ) {
                dataAll.push(InvDataSec.data.listEndUserSpecialPricings.items[i]);
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    return dataAll
  }
  const searchBtn = async () => {
   setProgress(true)
   let arr = [];
   let obj = {};
  let dataAll = [];
   try {
     dataAll = await searchData()
   } catch (error) {
       if (error.message === 'No current user') {
           //ユーザープールに障害が発生した場合
           console.log('User pool is invalid.Please reauthenticate.');
           //ログイン画面に戻る
           signOut();
       } else {
           //他のエラーを処理する
           console.log('An error occurred:', error);
       }
   }
   obj = searchValue;
   dataAll.forEach(item => {
     let flag = true
     if (Object.keys(obj).length !== 0) {
       for (let name in obj) {
         if (obj[name] !== "") {
           if (item[name]) {
             if (!(item[name]).includes(obj[name])) {
               flag = false;
               break;
             }
           } else {
             flag = false
             break;
           }
         }
       }
     }
     if (flag === true) {
       arr.push(item)
     }
   })
   if(authDisplay){
    arr = multiSort(arr,sortByEndUserCode)
   }else{
    arr = multiSort(arr,sortByOrderCode)
   }
   setTableData(arr)
   setProgress(false)
  }
  const searchClear = async()=>{
    setProgress(true)
    let arr = [];
    try {
        arr = await searchData()
    } catch (error) {
        if (error.message === 'No current user') {
            //ユーザープールに障害が発生した場合
            console.log('User pool is invalid.Please reauthenticate.');
            //ログイン画面に戻る
            signOut();
        } else {
            //他のエラーを処理する
            console.log('An error occurred:', error);
        }
    }
    if(authDisplay){
      arr = multiSort(arr,sortByEndUserCode)
     }else{
      arr = multiSort(arr,sortByOrderCode)
     }
    setSearchValue({EndUserCode: "",ItemCode: "",OrderCode:""})
    setTableData(arr)
    setProgress(false)
  }
  const signOut = async () => {
      await Auth.signOut();
      try {
          await Auth.signOut();
      } catch (error) {
          console.log("error signing out: ", error);
      }
      document.location.reload();
  };
  const getTypePriority = (str) => {
    if (!str || str.trim() === "") return 99;
    const firstChar = str[0];
    if (/^[0-9]/.test(firstChar)) return 1;
    if (/^[a-zA-Z]/.test(firstChar)) return 2;
    if (/^[\u30A0-\u30FF]/.test(firstChar)) return 3;
    if (/^[\u3040-\u309F\u4E00-\u9FFF]/.test(firstChar)) return 4;
    return 5;
  };
  const sortByEndUserCode = (a, b) => {
    const nameA = a.EndUserCode || "";
    const nameB = b.EndUserCode || "";
    const priorityA = getTypePriority(nameA);
    const priorityB = getTypePriority(nameB);
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  };
  const sortByOrderCode = (a, b) => {
    const nameA = a.OrderCode || "";
    const nameB = b.OrderCode || "";
    const priorityA = getTypePriority(nameA);
    const priorityB = getTypePriority(nameB);
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  };
  const multiSort = (arr, ...sortFuncs)=> {
    return arr.sort((a, b) => {
      for (const func of sortFuncs) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
      return 0;
    });
  }
  const [scrollTableWidth,setscrollTableWidth] = useState('101%')
  function calculateZoomLevel() {
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const zoomLevel = ((windowWidth / screenWidth) + (windowHeight / screenHeight)) / 2;
    return Math.round(zoomLevel * 100);
  }
  useEffect(() => {
    let lastZoomLevel = calculateZoomLevel();
    async function getEndUserList() {
      try {
        const userAuths = await userAuth();
        if (userAuths === "1") {
          setauthDisplay(true);
          setTitle("エンドユーザー特価一覧");
          let PriceList = [];
          const user = await Auth.currentUserInfo();
          const agencyPriceGroup = await API.graphql(
            graphqlOperation(customerByeMail, {
              Agency_Email: user.attributes.email,
            })
          );
          const agentinfo = agencyPriceGroup.data.customerByeMail["items"];
          let agencyId = "";
          if (agentinfo.length > 0) {
            agencyId = agentinfo[0].Agency_id;
          }
          const EndUserlist = await API.graphql(
            graphqlOperation(queryEndUserSpecialPricingsByOrderCodeIndex, {
              OrderCode: agencyId,
              limit: 1000,
            })
          );
          if (
            EndUserlist.data.queryEndUserSpecialPricingsByOrderCodeIndex !==
            null
          ) {
            let nextToken =
              EndUserlist.data.queryEndUserSpecialPricingsByOrderCodeIndex
                .nextToken;
            PriceList =
              EndUserlist.data.queryEndUserSpecialPricingsByOrderCodeIndex
                .items;

            while (nextToken !== null) {
              let InvDataSec = await API.graphql(
                graphqlOperation(queryEndUserSpecialPricingsByOrderCodeIndex, {
                  OrderCode: agencyId,
                  limit: 1000,
                  nextToken,
                })
              );
              if (
                InvDataSec.data.queryEndUserSpecialPricingsByOrderCodeIndex !==
                null
              ) {
                nextToken =
                  InvDataSec.data.queryEndUserSpecialPricingsByOrderCodeIndex
                    .nextToken;
                PriceList.push(
                  ...InvDataSec.data.queryEndUserSpecialPricingsByOrderCodeIndex
                    .items
                );
              } else {
                nextToken = null;
              }
            }
          }
          let itemCodeList = []
          let endUserCodeList = []
          let orderCodeList = []
          for (let i = 0; i < PriceList.length; i++) {
            if (PriceList[i].EndUserCode) {
                endUserCodeList.push(PriceList[i].EndUserCode)
                itemCodeList.push(PriceList[i].ItemCode)
                orderCodeList.push(PriceList[i].OrderCode)
              }
          }
          PriceList = multiSort(PriceList,sortByEndUserCode)
          setItemCodeList(Array.from(new Set(itemCodeList)))
          setEndUserCodeList(Array.from(new Set(endUserCodeList)))
          setOrderCodeList(Array.from(new Set(orderCodeList)))
          setTableData(PriceList);
        } else {
          setauthDisplay(false);
          setTitle("エンドユーザー特価マスタ");
          EndUserSpecialPricingInit();
        }
        const handleResize = () => {
          let dom = document.querySelector("#table");
          const newZoomLevel = calculateZoomLevel();
          if (lastZoomLevel !== newZoomLevel) {
            if (newZoomLevel > lastZoomLevel) {
              setscrollTableWidth(dom ? `101%` : `101%`)
            }else {
              let width = dom ? (`${dom.offsetWidth}` < 1632 ? `1632px` : '101%') : '101%';
              setscrollTableWidth(`${width}`)
            }
            lastZoomLevel = newZoomLevel;
          }
        };
        window.addEventListener('resize',handleResize, 100);
        return () => window.removeEventListener('resize', handleResize);
      } catch (err) {
        console.error(err);
      }
    }

    getEndUserList();
  }, []);
  //通常の形式を追加すると、数字のみを入力できます
  const changeRate = (e) => {
    setUpShow({ ...upShow, Price: e.target.value.replace(/[^0-9]/g, "") });
  };
  function moneytonum(val) {
    let num = val ? val.trim() : "";
    let ss = num.toString();
    if (ss.length === 0) {
      return "";
    }
    return ss.replace(/,/g, "");
  }
  function numtomoney(number, toFixed) {
    let str = [];
    if (!number) return "";
    if (typeof number === "number") number = String(number);
    let tempNumber = number.split(".");
    number = tempNumber[0];
    if (number.length <= 3) {
      if (tempNumber[1]) {
        number += "." + tempNumber[1].slice(0, toFixed);
      }
      return number;
    }
    number
      .split("")
      .reverse()
      .forEach((item, index) => {
        if (index !== 0 && index % 3 === 0) {
          str.push(",", item);
        } else {
          str.push(item);
        }
      });
    number = str.reverse().join("");
    if (tempNumber[1]) {
      number += "." + tempNumber[1].slice(0, toFixed);
    }
    return number;
  }
  const upRateFun = function () {
    //NULL 不可
    if (upShow.Price === "") {
      message.error(`価格の空にすることはできません`, 5);
      return;
    }
    upRate();
    setUpShow({ ...upShow, show: false });
    message.success(`正常に変更されました`, 5);
  };
  async function upRate() {
    try {
      await API.graphql(
        graphqlOperation(updateEndUserSpecialPricing, {
          input: {
            id: upShow.id,
            EndUserCode: upShow.EndUserCode,
            OrderCode: upShow.OrderCode,
            ItemCode: upShow.ItemCode,
            Price: upShow.Price
          },
        }))
        EndUserSpecialPricingInit()
      }catch(err){
        console.log(err)
              }
      }
   return(
    <Container
      style={{ backgroundColor: "", minWidth: "100%", minHeight: "74vh" }}
    >
      <Row
          style={{
            borderRadius: "0.25em",
            color: "purple",
            padding: "0.5em",
          }}>
            <div style={{ display: 'flex', marginBottom: "10px",width:"100%" }}>
                <Col>
                    <h4
                      style={{
                      textAlign: "left",
                      color: "black",
                      height: 30,
                      width: '20%',
                      borderLeft: "4px solid #804F29",
                      paddingLeft: "4px",
                      whiteSpace:"nowrap"
                      }}>{Title}
                    </h4>
                </Col>
                    <div style={{ width: '80%', height: 172 }}>
                      <div style={{ width: '90%',minWidth:"500px",height: 172, border: '2px solid rgb(191,191,191)', display:"flex",flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
                      <div style={{ width: "50%", height: '25px',display:authDisplay === false ? "inline-block" : "none" }}>
                              <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                                <InputGroup.Text
                                    className={classes.textlabel}
                                    id="basic-name"
                                    style={{ borderRadius: "0px",minWidth:"100px"}}
                                >受注先
                                </InputGroup.Text>
                                  <Autocomplete
                                    className={classes.textFieldSearch}
                                    sx={{
                                        display: 'inline-block',
                                        '& input': {
                                            width: 300,
                                            height: 0,
                                        },
                                    }}
                                    options={OrderCodeList}
                                    value={searchValue.OrderCode}
                                    name="OrderCode"
                                    onChange={(e, value) => { TextOrderCodeChange(e, value) }}
                                    renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                                    isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                                />
                              </InputGroup>
                          </div>
                          <div style={{ width: "50%", height: '25px' }}>
                              <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                                <InputGroup.Text
                                    className={classes.textlabel}
                                    id="basic-name"
                                    style={{ borderRadius: "0px",minWidth:"100px"}}
                                >エンドユーザー
                                </InputGroup.Text>
                                  <Autocomplete
                                    className={classes.textFieldSearch}
                                    sx={{
                                        display: 'inline-block',
                                        '& input': {
                                            width: 300,
                                            height: 0,
                                        },
                                    }}
                                    options={EndUserCodeList}
                                    value={searchValue.EndUserCode}
                                    name="EndUserCode"
                                    onChange={(e, value) => { TextEndUserCodeChange(e, value) }}
                                    renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                                    isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                                />
                              </InputGroup>
                          </div>
                          <div style={{ width: authDisplay === false ? "100%" : "50%", height: '25px', }}>
                              <InputGroup className="mb-3" style={{ width: authDisplay === false ? "50%" : "100%", display: 'flex', flexWrap: "nowrap", }}>
                                <InputGroup.Text
                                    className={classes.textlabel}
                                    id="basic-name"
                                    style={{ borderRadius: "0px",minWidth:"100px"}}
                                >品目
                                </InputGroup.Text>
                                <Autocomplete
                                  className={classes.textFieldSearch}
                                  sx={{
                                      display: 'inline-block',
                                      '& input': {
                                          height: 0,
                                      },
                                  }}
                                  options={ItemCodeList}
                                  id="EndUserCode"
                                  value={searchValue.ItemCode}
                                  name="ItemCode"
                                  onChange={(e, value) => { TextItemCodeChange(e, value) }}
                                  renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                                  isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                                />
                              </InputGroup>
                          </div>
                          <div style={{margin:"auto"}}>
                              <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                              <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
                          </div>
                      </div>
                    </div>
            </div>
          </Row>
      <ToolkitProvider keyField="id" data={products} columns={columns}>
        {(props) => (
          <div>
           <div
            style={{
              width: "100%",
              height: "100%",
              overflowX: "scroll",
              transform: "scaleY(-1)",
            }}
          >
            <div
              style={{
                width: scrollTableWidth,
                height: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
                transform: "scaleY(-1)",
              }}
            >
              <div style={{ direction: "ltr" }}>
            <BootstrapTable
              id="table"
              bootstrap4
              striped={true}
              hover={true}
              headerStyle
              keyField="id"
              condensed
              columns={columns}
              data={products}
              {...props.baseProps}
              pagination={paginationFactory(options)}
              noDataIndication={"no results found"}
              headerClasses={classes.fixedTop}
            />{" "}
          </div>
        </div>
        </div>
        </div>
        )}
      </ToolkitProvider>
      <div
              style={{
                position: "absolute",
                top: "50%",
                left: "55%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <CircularProgress
                size="3rem"
                disableShrink
                sx={{
                  color: "#3f51b5",
                  margin: "auto",
                  display: progress ? "block" : "none",
                  marginLeft: "60px",
                }}
              />
          </div>
      <Dialog
    open={upShow.show}
    fullWidth={true}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    style={{zIndex:500}}
  >
  <DialogContent>
            <p style={{fontSize:"20px"}}>エンドユーザー編集</p>
            <InputGroup className="mb-3">
            <InputGroup.Text className={classes.textField} id="basic-name"><span style={{color:"red"}}></span>受注先コード</InputGroup.Text>
            <FormControl
              placeholder=""
              aria-label=""
              defaultValue={upShow.OrderCode}
              aria-describedby="basic-name"
              className={classes.textFieldNm}
              maxLength="40"
            />
          </InputGroup>
           <InputGroup className="mb-3">
            <InputGroup.Text className={classes.textField} id="basic-name">エンドユーザー</InputGroup.Text>
            <FormControl
              placeholder=""
              aria-label=""
              readOnly
              defaultValue={upShow.EndUserCode}
              aria-describedby="basic-name"
              className={classes.textFieldNm}
              maxLength="40"
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text className={classes.textField} id="basic-name"><span style={{color:"red"}}></span>品目コード</InputGroup.Text>
            <FormControl
              placeholder=""
              aria-label=""
              readOnly
              defaultValue={upShow.ItemCode}
              aria-describedby="basic-name"
              className={classes.textFieldNm}
              maxLength="40"
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text className={classes.textField} id="basic-name"><span style={{color:"red"}}>*</span>価格</InputGroup.Text>
            <FormControl
              placeholder=""
              aria-label=""
              //フォーマットを追加
              value={numtomoney(moneytonum(upShow.Price))}
              aria-describedby="basic-name"
              className={classes.textFieldNm}
              onChange={(e)=>changeRate(e)}
              maxLength="40"
            />
          </InputGroup>
        <div style={{width:"36%",display:"flex",float:"right",paddingTop:"3%"}}>
        <Button variant="contained" color="primary" style={{
       minWidth:"104px",
       width:"104px",
       fontSize: "14px",
       padding: "5px",
       height: "36.5px",
       color:"white",
      }} onClick = {upRateFun}>OK</Button>
      <Button variant="contained" color="primary" style={{
       minWidth:"104px",
       width:"104px",
       fontSize: "14px",
       padding: "5px",
       height: "36.5px",
       marginLeft:"7px",
       color:"white",
      }} onClick = {upHiddenFun}>キャンセル</Button>
      </div>
    </DialogContent>
  </Dialog>
       </Container>
)
}
export default EndUserSpecialPricing


